import React from 'react';
import HeroSection from '../components/HeroSection';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

function HomePage() {


  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <HeroSection />
      
      {/* Featured Courses */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-4xl md:text-5xl font-bold text-slate-900 mb-6"
            >
              Featured Courses
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-xl text-slate-600 max-w-3xl mx-auto"
            >
              Master the skills you need to succeed in the business world.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                id: 1,
                title: "Entrepreneurship & Business Idea Development",
                category: "Entrepreneurship",
                price: "$497",
                duration: "8 weeks"
              },
              {
                id: 2,
                title: "Company Formation & Financial Management",
                category: "Business Setup",
                price: "$397",
                duration: "6 weeks"
              },
              {
                id: 3,
                title: "E-Export & Digital Marketing",
                category: "Global Expansion",
                price: "$597",
                duration: "10 weeks"
              },
              {
                id: 4,
                title: "Growth & Investment Strategies",
                category: "Growth & Investment",
                price: "$697",
                duration: "12 weeks"
              }
            ].map((course) => (
              <motion.div
                key={course.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: course.id * 0.1 }}
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 border border-slate-100 h-full flex flex-col"
              >
                <div className="mb-4">
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                    {course.category}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 line-clamp-2 flex-1 min-h-[3rem]">
                  {course.title}
                </h3>
                <div className="flex items-center justify-between mb-4">
                  <span className="text-2xl font-bold text-blue-600">{course.price}</span>
                  <span className="text-slate-600 text-sm">{course.duration}</span>
                </div>
                <Link
                  to={`/purchase/${course.id}`}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-3 rounded-lg transition-all duration-300 inline-flex items-center justify-center space-x-2 mt-auto"
                >
                  <span>Purchase</span>
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="text-center mt-12"
          >
            <Link
              to="/courses"
              className="btn-primary text-lg px-8 py-4"
            >
              View All Courses
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
